import { BannerSliderStyleTokens } from "@omni/ui/brand/bannerSlider/bannerSlider.tokens";
import { UIBannerSlider } from "@omni/ui/components/BannerSlider/bannerSlider.styles";
import { tv } from "tailwind-variants";

export const BannerSliderStyles: BannerSliderStyleTokens = {
    navButtonColor: "gray"
};

export const bannerSlider = tv({
    extend: UIBannerSlider,
    slots: {
        slider_navButton: [
            "tw:p-0 tw:text-xl tw:absolute tw:top-1/2 tw:rounded-full tw:translate-y-[-50%] tw:layer-base/[2] tw:min-h-8 tw:min-w-8 tw:justify-center tw:items-center tw:opacity-100! tw:text-secondary tw:shadow-md",
            "tw:hidden",
            "tw:md:flex"
        ],
        slider_navButton_icon: "las"
    },
    variants: {
        type: {
            left: {
                slider_navButton_icon: "la-arrow-left"
            },
            right: {
                slider_navButton_icon: "la-arrow-right"
            }
        }
    }
});
